import React from 'react';
import { CountUp, Reveal } from './Reveal';
import { AlertTriangle, Droplets, MapPin, Recycle, Calendar, Trophy, Sun } from 'lucide-react';
import { useSection } from '../contexts/ContentContext';

const ICON_MAP = { Droplets, AlertTriangle, MapPin, Recycle, Calendar, Trophy, Sun };
const colors = [
  'from-sky-400 to-sky-600',
  'from-rose-400 to-orange-500',
  'from-amber-400 to-orange-500',
  'from-emerald-400 to-teal-500',
  'from-purple-400 to-pink-500',
  'from-emerald-500 to-sky-500',
];
const ICON_ROTATION = [Droplets, AlertTriangle, MapPin, Recycle, Calendar, Trophy];

export default function StatsSection() {
  const home = useSection('home');
  const s = home.stats || {};
  const items = s.items || [];

  return (
    <section className="relative py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Reveal>
            {s.eyebrow && <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-3">{s.eyebrow}</span>}
            <h2 className="font-display font-extrabold text-4xl lg:text-5xl text-sky-950 mb-5 leading-tight">
              {s.title} <span className="gradient-text">{s.titleHighlight}</span>
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed">{s.description}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((stat, i) => {
            const Icon = ICON_ROTATION[i % ICON_ROTATION.length];
            return (
              <Reveal key={i} delay={i * 80}>
                <div className="group relative bg-gradient-to-br from-white to-sky-50/50 rounded-3xl border border-sky-100 p-7 hover:shadow-xl hover:shadow-sky-100/50 hover:-translate-y-1 transition-all duration-300">
                  <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${colors[i % colors.length]} flex items-center justify-center mb-5 shadow-lg group-hover:scale-110 transition-transform`}>
                    <Icon className="w-7 h-7 text-white" strokeWidth={2.2} />
                  </div>
                  <div className="font-display font-extrabold text-5xl lg:text-6xl text-sky-950 leading-none mb-2">
                    <CountUp value={Number(stat.value) || 0} suffix={stat.suffix || ''} decimals={(stat.value % 1 !== 0) ? 1 : 0} />
                  </div>
                  <p className="font-semibold text-sky-800 mb-1">{stat.label}</p>
                  <p className="text-sm text-slate-500 leading-relaxed">{stat.sublabel}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        {(s.footer || s.footerSub) && (
          <Reveal delay={200}>
            <div className="mt-12 max-w-3xl mx-auto text-center p-8 rounded-3xl bg-gradient-to-r from-sky-50 to-emerald-50 border border-sky-100">
              <p className="text-lg text-sky-900 font-medium leading-relaxed">
                {s.footer && <span className="font-display font-bold text-xl block mb-2">{s.footer}</span>}
                {s.footerSub}
              </p>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
